/* eslint-disable import/no-anonymous-default-export */
import Login from "./auth/Login";
import ForgotPassword from "./auth/ForgotPassword";
import OtpVerification from "./auth/otp";
import ResetPassword from "./auth/ResetPassword";
import Dashboard from "./dashboard";
import ManageUser from "./manageUsers";
import ManageUserDetail from "./manageUsers/view";
import ManageSubadmin from "./manageSubadmin";
import ManageNotifications from "./manageNotifications";
import RecievedNotifications from "./recievedNotifications";
import ManageCms from "./manageCms";
import SubadminDetail from "./manageSubadmin/viewSubadmin";
import AddSubadmin from "./manageSubadmin/addSubadmin";
import ManageSubadminRoles from "./manageSubadmin/roles";
import AddRole from "./manageSubadmin/addRole";
import RoleDetail from "./manageSubadmin/viewRole";
import ManageProfile from "./manageProfile";
import EditProfile from "./manageProfile/edit";
import ChangePassword from "./manageProfile/changePassword";
import Edituser from "./manageUsers/edit";
import ManagePromotion from "./manage-promotion";
import AddPromotion from "./manage-promotion/addPromotion";
import AddNotification from "./manageNotifications/add";
import NotificationDetail from "./manageNotifications/view";
import ManageSystemSettings from "./manageSystemSettings";
import AddEmailTemplate from "./manageSystemSettings/addcampaigntype";
import ManageStores from "./manageStores";
import AddStore from "./manageStores/add";
import StoreDetail from "./manageStores/view";
import ManageQrCode from "./manageQrCode";
import ManageRewards from "./manageRewards";
import AddRewards from "./manageRewards/add";
import RewardsDetail from "./manageRewards/view";
import ViewPromotion from "./manage-promotion/viewPromotion";
import ManageTransction from "./manage-transction";
import ViewTransction from "./manage-transction/viewTransction";
import ManageActivityLogs from "./manageActivityLogs";
import ManageFeedbackReports from "./manageFeedbackReports";
import ManageCustomers from "./manage-customers";
import AddCustomer from "./manage-customers/add-customer";
import ViewCustomer from "./manage-customers/details";
import ManageVendors from "./manage-vendors";
import ViewVendor from "./manage-vendors/view-vendor";
import ManageServiceProviders from "./manage-service-providers";
import AddServiceProvider from "./manage-service-providers/add";
import ViewServiceProvider from "./manage-service-providers/view";
import ManageCategories from "./manage-categories";
import ManageSubCategories from "./manage-categories/manage-sub-category";
import ManageAttributes from "./manage-categories/manage-attributes";
import ManageBrands from "./manage-brands";
import ManageRecommendedProducts from "./recommended-products";
import ViewProduct from "./productManagement/viewProduct";
import OrderManagement from "./order-management";
import Payments from "./payments";
import Revenue from "./manage-revenue";
import LoyaltyPoints from "./loyalty-points";
import AddLoyalty from "./loyalty-points/add";
import DiscountCoupon from "./DiscountAndCoupon/discountCoupon";
import AddDiscount from "./DiscountAndCoupon/add";
import Subscriptions from "./subscription";
import EditSubscription from "./subscription/edit";
import ViewSubscription from "./subscription/view";
import AdBanner from "./ad-banner-management";
import AddAdBanner from "./ad-banner-management/add";
import ViewAdBanner from "./ad-banner-management/view";
import CustomerSupport from "./customer-support";
import Ratings from "./ratings";
import Blogs from "./blogs";
import AddBlog from "./blogs/add";
import FoundersPass from "./fikra-lab/founders-pass";
import FikraLabBusinessReport from "./fikra-lab/business-report";
import ViewBusinessReport from "./fikra-lab/business-report/view";
import AddCampaignType from "./manageSystemSettings/addcampaigntype";
import ViewFieldTemplates from "./manageSystemSettings/view-field-templates";
import VendorLanding from "./manage-vendor-landing";
import ViewPurchaseServices from "./manage-vendors/view-service";
import ViewCampaign from "./manage-vendors/view-campaign";
import AiInsights from "./ai-insights";
import ViewAiInsightsStatic from "./ai-insights/view";
import VendorBlogs from "./blogs/vendorBlogs";
import PendingApprovals from "./blogs/pendingApproval";
import ViewVendorBlogs from "./blogs/view-blog-vendor";
import ViewOrderManagement from "./order-management/view";
import VendorSupport from "./vendor-support";
import SPSupport from "./service-provider-support";
import KnowledgeBase from "./knowledge-base/page";
import VideoTutorials from "./video-tutorials/page";
import AddVideoTutorial from "./video-tutorials/add";
import AddKnowledgeBase from "./knowledge-base/add";
import ServiceProviderLanding from "./manage-sp-landing";
import Chat from "./chat";
import EditVendor from "./manage-vendors/edit-vendor";
import AddVendor from "./manage-vendors/add-vendor";
import ViewOnboarding from "./manage-vendors/view-onboarding";
import ViewSPOnboarding from "./manage-service-providers/view-onboarding";
import ManageCollections from "./manage-collections";
import ViewCollection from "./manage-collections/view";

import Services from "./services";
import ReturnandRefund from "./retrunrefund";
import Commissions from "./commissions";
import VendorRatings from "./vendor-reviews";
import ReturnOrderView from "./retrunrefund/view";
import DeliveryZones from "./delivery-zones";
import ShippingRates from "./shipping-rates";
import LogisticHub from "./logistic-hub";
import LogisticAPI from "./logisticsapi";
import PlatformFees from "./platformfees";
import CommissionBySubscription from "./commissions/view";
import ServiceBookings from "./serviceBookings";
import PricingAnalytics from "./pricing-analytics";
import VendorPayouts from "./payments/vendor-payouts";
import ServiceProviderPayouts from "./payments/service-provider-payouts";
import VatInvoicing from "./payments/vat-invoicing";
import ViewPayout from "./payments/view-payout";
import FinancialReports from "./financial-reports";
import ViewTransactionLogs from "./financial-reports/view-transaction-logs";
import ViewPayoutSP from "./payments/view-payout-sp";
import ViewInvoice from "./payments/view-invoice";
import MediaLibrary from "./media-library";
import HomeLayout from "./home-layout";
import ViewHomeLayout from "./home-layout/view";
import ManageGroups from "./manage-groups";
import ManageTags from "./manage-groups/manage-tags";
import PersonaDashboard from "./persona-dashboard";
import ViewPersona from "./persona-dashboard/view-persona";
import IncidentCenter from "./incident-center";
import TrustComplianceOverview from "./trust-compliance/overview";
import ComlpliancePolicies from "./trust-compliance/policies";
import DataProcessing from "./trust-compliance/data-processing";
import RiskRegistry from "./trust-compliance/risk-resgistry";
import ViewDiscount from "./DiscountAndCoupon/view";
import AIHub from "./ai-hub";
import CostAnalytics from "./cost-analytics";
import VendorCredits from "./ai-credit-manager";
import VendorCampaigns from "./vendor-campaigns";
import ViewPolicies from "./trust-compliance/policies/view";
import VendorContracts from "./vendor-contarct";
import ViewContract from "./vendor-contarct/view";
import EditContract from "./vendor-contarct/edit";
import VendorHealthScore from "./vendor-health-score";
import ViewVendorSubscription from "./manage-vendors/vendor-subscription";
import ViewMilestone from "./manage-vendors/view-milestone";
import ViewTier from "./manage-customers/viewTier";
import ViewSegment from "./manage-customers/viewSegment";
import CustomerTimeline from "./manage-customers/viewTimeline";
import StoreInformation from "./manage-vendors/storeInformation";
import ViewVendorSegment from "./manage-vendors/viewSegment";
import ManageAutomation from "./vendor-health-score/manage-automation";
import AICommandCenter from "./ai-behaviour/ai-command-center";
import AIBrain from "./ai-brain";
import AiCapabilitiesPage from "./ai-behaviour/ai-capabilities";
import AIAutonomy from "./ai-behaviour/ai-autonomy";
import CreateFikraForm from "./fikra-lab/create-form";
import BouteekCommunity from "./bouteek-community";
import AiCampaignBuilder from "./ai-campaign-builder";
import CustomerHealthScore from "./customer-health-score";
import AddService from "./services/add-service";
import BouteekBranding from "./bouteekBranding";
import PaymentMethods from "./payment-methods/indes";
import FikraLabPlans from "./fikra-lab/plans";
import AddFikraLabPlan from "./fikra-lab/plans/add";
import FikraLabFeatures from "./fikra-lab/features";
import FounderPassSettings from "./fikra-lab/founder-pass";
import ServiceProviderContracts from "./service-provider-contract";
import ViewSPContract from "./service-provider-contract/view";
import EditSPContract from "./service-provider-contract/edit";
import SPHealthScore from "./sp-health-score";
import HomePageBanners from "./manage-home-banners";

import AIPolicies from "./ai-behaviour/ai-policies";

import AIDecisions from "./ai-behaviour/ai-decisions";
import AIReports from "./ai-behaviour/ai-reports";
import ManageAppIntro from "./manage-app-intro";
import AIRoiBusinessImpact from "./ai-behaviour/ai-roi-business-impact";
import AILearningFeedback from "./ai-behaviour/ai-learning-feedback";
import AIDataSync from "./ai-behaviour/ai-data-sync";
import AISubscriptionUsage from "./ai-behaviour/ai-subscription-usage";
import AIAuditGovernance from "./ai-behaviour/ai-audit-governance";
import AIHealthDrift from "./ai-behaviour/ai-health-drift";

export default {
  Login,
  ForgotPassword,
  OtpVerification,
  ResetPassword,
  Dashboard,
  ManageUser,
  Edituser,
  ManageUserDetail,
  ManageSubadmin,
  SubadminDetail,
  AddSubadmin,
  ManageSubadminRoles,
  Subscriptions,
  EditSubscription,
  ViewSubscription,
  AdBanner,
  AddAdBanner,
  ViewAdBanner,
  CustomerSupport,
  Ratings,
  BouteekCommunity,
  Blogs,
  FikraLabBusinessReport,
  ViewBusinessReport,
  FoundersPass,
  AddRole,
  Revenue,
  ViewDiscount,
  AddDiscount,
  AiCampaignBuilder,
  AddCampaignType,
  AddBlog,
  VendorLanding,
  StoreInformation,
  LoyaltyPoints,
  AddLoyalty, DiscountCoupon,
  RoleDetail,
  ViewProduct,
  ViewPurchaseServices,
  ViewCampaign,
  ViewOnboarding,
  ManageCustomers,
  ServiceProviderPayouts,
  ViewPayout,
  ViewFieldTemplates,
  ManageNotifications,
  AddNotification,
  NotificationDetail,
  RecievedNotifications,
  VendorPayouts,
  FinancialReports,
  VatInvoicing,
  Payments,
  PricingAnalytics,
  FounderPassSettings,
  ManageCms,
  CommissionBySubscription,
  ManageProfile,
  EditProfile,
  ChangePassword,
  ManageSystemSettings,
  AddCustomer,
  CustomerTimeline,
  OrderManagement,
  ServiceBookings,
  Services,
  ReturnandRefund,
  PlatformFees,
  ShippingRates,
  Commissions,
  DeliveryZones,
  LogisticHub,
  LogisticAPI,
  ManageCollections,
  ViewCollection,

  AddVendor,
  ManageRecommendedProducts,
  ViewContract,
  VendorRatings,
  ViewSPOnboarding,
  ViewTier,
  ViewSegment,
  ViewVendorSegment,
  ReturnOrderView,
  VendorContracts,
  ManageVendors,
  AddServiceProvider,
  VendorHealthScore,
  ViewVendorSubscription,
  ManageServiceProviders,
  CostAnalytics,
  ManagePromotion,
  ViewPolicies,
  ManageCategories,
  ManageSubCategories,
  VendorCampaigns,
  ViewMilestone,

  ManageBrands,
  ManageAttributes,
  AddPromotion,
  VendorCredits,
  AIHub,
  AddEmailTemplate,
  ManageStores,
  ViewCustomer,
  ViewVendor,
  ViewServiceProvider,
  AddStore,
  StoreDetail,
  ManageQrCode,
  ManageRewards,
  AddRewards,
  RewardsDetail,
  MediaLibrary,
  ViewPromotion,
  ManageTransction,
  HomeLayout,
  ViewHomeLayout,
  ViewInvoice,
  ViewTransction,
  ManageActivityLogs,
  ManageFeedbackReports,
  ViewPayoutSP,
  AiInsights,
  ViewAiInsightsStatic,
  ViewTransactionLogs,
  VendorBlogs,
  PendingApprovals,
  ViewVendorBlogs,
  VendorSupport,
  ViewOrderManagement,
  SPSupport,
  KnowledgeBase,
  VideoTutorials,
  AddVideoTutorial,
  EditVendor,
  PaymentMethods,
  ServiceProviderLanding,
  TrustComplianceOverview,
  AddKnowledgeBase,
  ComlpliancePolicies,
  RiskRegistry,
  Chat,
  DataProcessing,
  ManageTags,
  ManageGroups,
  ViewPersona,
  PersonaDashboard,
  IncidentCenter,
  ManageAutomation,
  AICommandCenter,
  AIBrain,
  AiCapabilitiesPage,
  AIAutonomy,
  CreateFikraForm,
  AddService,
  BouteekBranding,
  CustomerHealthScore,
  FikraLabPlans,
  AddFikraLabPlan,
  FikraLabFeatures,
  EditContract,
  ServiceProviderContracts,
  ViewSPContract,
  EditSPContract,
  AIPolicies,
  AIDecisions,
  AIReports,
  SPHealthScore,
  HomePageBanners,
  ManageAppIntro,
  AIRoiBusinessImpact,
  AILearningFeedback,
  AIDataSync,
  AISubscriptionUsage,
  AIAuditGovernance,
  AIHealthDrift
};

